export default __webpack_public_path__ + "static/roadmap_tablet@2x-c2982829b6fad74859893db51a1c51d5.png";